import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=0f040a0b"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"
import style0 from "./GenericModal.vue?vue&type=style&index=0&id=0f040a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports